import { render, staticRenderFns } from "./SearchResultsPaginationControls.vue?vue&type=template&id=f7f47100&scoped=true&lang=pug&"
import script from "./SearchResultsPaginationControls.vue?vue&type=script&lang=js&"
export * from "./SearchResultsPaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsPaginationControls.vue?vue&type=style&index=0&id=f7f47100&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f47100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7f47100')) {
      api.createRecord('f7f47100', component.options)
    } else {
      api.reload('f7f47100', component.options)
    }
    module.hot.accept("./SearchResultsPaginationControls.vue?vue&type=template&id=f7f47100&scoped=true&lang=pug&", function () {
      api.rerender('f7f47100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/search/SearchResultsPaginationControls.vue"
export default component.exports